import { useQuery } from '@tanstack/react-query';
import { fetchDiffsCrosstab } from '@/utils/diffsAnalyticsAPI';
import type { DiffsCrosstabRequest, DiffsCrosstabResponse } from '@/components/reports/graphs/types';

export function useDiffsCrosstab(request: DiffsCrosstabRequest | null) {
  const result = useQuery<DiffsCrosstabResponse, Error>({
    queryKey: ['diffsCrosstab', request],
    queryFn: () => {
      if (!request) {
        throw new Error('No request provided');
      }
      return fetchDiffsCrosstab(request);
    },
    enabled: !!request && !!request.periods && request.periods.length >= 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 2,
  });

  return result;
}
